export default {
  props: {
    name: {
      type: String,
      default: null
    },

    label: {
      type: String,
      default: null
    },

    alias: {
      type: String,
      default: null
    },

    //DOM Element Input property
    //'list': {},

    mask: String,

    disabled: {
      type: [String, Boolean],
      default: false
    },

    type: {
      type: String,
      default: "text"
    },

    validationConfig: {
      type: String,
      default: null
    },

    value: {}
  },

  created() {
    this.registerField();
  },

  methods: {
    registerField() {
      if (this.isChild) {
        this.$parent.registerField(this);
      }
    }
  },

  computed: {
    fieldAlias() {
      return this.alias || (this.label ? this.label.toLowerCase() : this.name);
    },

    parentForm() {
      if (this.isChild)
        return this.$parent.isForm
          ? this.$parent
          : this.$parent.isFormGroup
          ? this.$parent.parentForm
          : null;
      else return null;
    },

    isChild() {
      return Boolean(
        this.$parent && (this.$parent.isForm || this.$parent.isFormGroup)
      );
    },

    hasName() {
      return this.name != null;
    },

    hasValidateConfig() {
      return this.validationConfig != null;
    }
  }
};
